import { createContext, useContext } from "react";

interface ClientStyleContextData {
  reset: () => void;
}

const ClientStyleContext = createContext<ClientStyleContextData>({
  reset: () => null,
});

const useClientStyleContext = () => {
  return useContext(ClientStyleContext);
};

export { ClientStyleContext, useClientStyleContext, type ClientStyleContextData };
